      <version-breadcrumb-header
        [version]="version"
        [title]="'PREVIEW'"
        [breadcrumbs]="breadcrumbs"
      ></version-breadcrumb-header>
      <div class="version"  *ngIf="status == STATUS_DONE">
          <versions-details-content-preview-file-main
              [version]="versionRelated"
              [file]="file"
              [menu]="menu"
              (menuClick)="onMenuClick($event)"
          ></versions-details-content-preview-file-main>
      </div>
      <div class="loader" [hidden]="status != STATUS_LOADING">
        <div class="dimmed">
          <div class="dimmed_flex">
            <div class="dimmed_content dimmed_versions">
              <div class="dimmed_title"></div>
              <div class="dimmed_subtitle"></div>
              <div class="dimmed_subtitle"></div>
            </div>
            <div class="dimmed_status"></div>
          </div>
        </div>
        <!-- <core-helpers-box-loading [hidden]="status != STATUS_LOADING"></core-helpers-box-loading> -->
      </div>
      
